import { Image } from "react-datocms";
import { resolveDatoImageLabel } from "@/lib/functions";
import styles from "./index.module.scss";

const siteName = process.env.NEXT_PUBLIC_WEBSITE_NAME;

interface ImageProps {
  data: any;
  className?: string;
  ariaHidden?: any;
  draggable?: any;
  layout?: any;
  lazyLoad?: any;
  onLoad?: any;
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  style?: React.CSSProperties;
}

function resolveImageTitle(data: any): string | undefined {
  const title = data?.responsiveImage?.title || data?.title;
  return typeof title === "string" && title.trim() ? title : undefined;
}

export default function CustomImage({
  data,
  className,
  ariaHidden,
  draggable,
  layout,
  lazyLoad,
  onLoad,
  objectFit,
  style: styleProp,
}: ImageProps) {
  if (!data) {
    return <></>;
  }

  if (!data.responsiveImage) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={data.url || data}
        width={data?.width}
        height={data?.height}
        alt={ariaHidden ? "" : resolveDatoImageLabel(data, siteName)}
        title={resolveImageTitle(data)}
        className={className}
        style={styleProp}
        draggable={draggable}
        loading={"lazy"}
        aria-hidden={ariaHidden}
      ></img>
    );
  }

  const style = {
    "--x": `${data?.focalPoint?.x}%`,
    "--y": `${data?.focalPoint?.y}%`,
    ...(styleProp ?? {}),
  } as React.CSSProperties;

  const altText = ariaHidden ? "" : resolveDatoImageLabel(data, siteName);
  const titleText = resolveImageTitle(data);

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <Image
      style={style}
      data={{
        ...data.responsiveImage,
        alt: altText,
        ...(titleText ? { title: titleText } : {}),
      }}
      layout={layout || "responsive"}
      onLoad={onLoad}
      objectFit={objectFit}
      className={[className, styles.image].filter(Boolean).join(" ")}
      fadeInDuration={10}
      lazyLoad={lazyLoad ?? true}
      usePlaceholder={false}
    />
  );
}
